// Shared shell for post-payment flow steps (disclaimer, profile, instructions).

import React from 'react';
import './flow.css';

export const ADHOC_FLOW_TOTAL_STEPS = 4;

interface AdhocFlowLayoutProps {
  currentStep: number;
  stepLabel: string;
  children: React.ReactNode;
}

const AdhocFlowLayout: React.FC<AdhocFlowLayoutProps> = ({
  currentStep,
  stepLabel,
  children,
}) => (
  <div className="adhoc-flow">
    <div className="flow-rail" aria-hidden="true">
      {Array.from({ length: ADHOC_FLOW_TOTAL_STEPS }, (_, i) => {
        const step = i + 1;
        let className = 'seg';
        if (step < currentStep) className += ' done';
        else if (step === currentStep) className += ' active';
        return (
          <div key={step} className={className}>
            <span />
          </div>
        );
      })}
    </div>
    <div className="flow-rail-label">
      Step {currentStep} of {ADHOC_FLOW_TOTAL_STEPS} — {stepLabel}
    </div>
    <div className="flow-screen">
      {children}
    </div>
  </div>
);

export default AdhocFlowLayout;
